import React, { useContext } from 'react';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import DataAndMethodsContext from '../../context/dataAndMethods/dataAndMethodsContext';
import { Tooltip } from '@mui/material';

const DefaultBotToolBar = () => {
  const dataAndMethodsContext: any = useContext(DataAndMethodsContext);
  const { myStates } = dataAndMethodsContext;

  return (
    <>
      <Toolbar color='primary' component='div'>
        <Tooltip title='Help and information'>
          <IconButton
            aria-label=''
            color={myStates['info'] ? 'secondary' : 'primary'}
            onClick={() => dataAndMethodsContext.setMyState('info')}
          >
            <i className='fas fa-question'></i>
          </IconButton>
        </Tooltip>
      </Toolbar>
    </>
  );
};

export default DefaultBotToolBar;
